export const getContactChargeCreationObject = (data) => {
  let objectTemp = {
    name: data.name,
  };

  return objectTemp;
};

export const getContactChargeUpdatenObject = (data) => {
  let objectTemp = {
    name: data.name,
  };

  return objectTemp;
};
